import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-http-backend';

// Get language from localStorage or browser
const getInitialLanguage = () => {
  const storedLanguage = localStorage.getItem('lng');
  if (storedLanguage) {
    return storedLanguage;
  }
  const browserLanguage = navigator.language.split('-')[0];
  return browserLanguage === 'hu' ? 'hu' : 'en';
};

const initialLanguage = getInitialLanguage();

i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: initialLanguage,
    fallbackLng: 'hu',
    ns: ['translations'],
    defaultNS: 'translations',
    backend: {
      loadPath: '/locales/{{lng}}.json'
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    }
  });

// Ensure the language is set correctly after initialization
i18n.on('initialized', () => {
  const storedLanguage = localStorage.getItem('lng');
  if (storedLanguage && storedLanguage !== i18n.language) {
    i18n.changeLanguage(storedLanguage);
  }
});

i18n.languages = ['hu', 'en']; // Language options

export default i18n;
